import React from 'react';
import classnames from 'classnames';
import { getDeviationType } from '../../../../_helpers';
import { DeviationTypes } from '../../../../../types/deviation';
import { LoveSlider } from '../../../../../LoveMeter';
import OverlayControl from './OverlayControl';
import s from '../Overlay.scss';
var LoveControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, statClassName = _a.statClassName, orientation = _a.orientation, loveCount = _a.loveCount, iconType = _a.iconType;
    var deviationType = getDeviationType(deviation);
    var isLoveable = ![
        DeviationTypes.COMMISSION,
        DeviationTypes.POLL,
        DeviationTypes.STATUS,
    ].includes(deviationType);
    if (!isLoveable) {
        return null;
    }
    return (React.createElement(OverlayControl, { stat: loveCount, title: "hearts", className: className, statClassName: statClassName },
        React.createElement(LoveSlider, { orientation: orientation, className: classnames(s['icon-button'], s['no-ring']), isFilled: iconType === 'filled' })));
};
LoveControl.displayName = 'LoveControl';
export default LoveControl;
//# sourceMappingURL=Love.js.map